import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <h1 className="logo">Mahtab Care</h1>
          <div className="tagline">Licensed Home Daycare</div>
        </div>
        <div className="header-badges">
          <div className="badge licensed">
            <span className="badge-icon">✅</span>
            <span>Licensed</span>
          </div>
          <div className="badge cwelcc">
            <span className="badge-icon">🇨🇦</span>
            <span>CWELCC</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;